import React from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { IntlProvider } from 'common/components/Intl';
import { configureLocales } from 'common/locales';

interface Props {
  store: Store;
  locale: string;
  translatedMessages: Record<string, string>;
}

export class WrappedBase extends React.Component<Props> {
  constructor(props) {
    super(props);
    configureLocales(props.locale);
  }

  render() {
    return (
      <Provider store={this.props.store}>
        <IntlProvider
          locale={this.props.locale}
          messages={this.props.translatedMessages}
        >
          {this.props.children}
        </IntlProvider>
      </Provider>
    );
  }
}
